import React, { FC } from 'react';
import MessagePlaceholder from '../../ui/Content/Message/MessagePlaceholder';

interface INotificationProps {
  title?: string;
  message?: string;
  icon?: string;
  id?: string;
}
const Notification: FC<INotificationProps> = ({
  title,
  message,
  icon = 'colored--40--green-check',
  id,
}) => (
  <MessagePlaceholder icon={icon} title={title} indents="24-16" id={id}>
    {message}
  </MessagePlaceholder>
);

export default Notification;
